import { useTranslation } from 'react-i18next';

interface PeriodNavigatorProps {
    label: string;
    onPrev: () => void;
    onNext: () => void;
    atOldest: boolean;
    atNewest: boolean;
}

const PeriodNavigator = ({ label, onPrev, onNext, atOldest, atNewest }: PeriodNavigatorProps) => {
    const { t } = useTranslation();

    return (
        <div className="d-flex align-items-center justify-content-between w-100">
            <button
                type="button"
                className={`yearBtn${atOldest ? '' : ' cursorpointer'}`}
                onClick={onPrev}
                disabled={atOldest}
                aria-label={String(t('vossusage.period.previous'))}
            >
                <i className="vismaicon vismaicon-sm vismaicon-arrow-left-circle" aria-hidden="true" />
            </button>
            <span>{label}</span>
            <button
                type="button"
                className={`yearBtn${atNewest ? '' : ' cursorpointer'}`}
                onClick={onNext}
                disabled={atNewest}
                aria-label={String(t('vossusage.period.next'))}
            >
                <i className="vismaicon vismaicon-sm vismaicon-arrow-right-circle" aria-hidden="true" />
            </button>
        </div>
    );
};

export default PeriodNavigator;
